import { useContext, useEffect } from 'react'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { FieldValues, UseFormReset } from 'react-hook-form'
import { AppContext } from '../../context/AppContext'
import ErrorBoundary from '../error/ErrorBoundary'

interface ModalFormProps {
    open: boolean,
    title: { icon: IconProp, label: string },
    onSubmit: (e?: React.BaseSyntheticEvent) => Promise<void>
    children: React.ReactNode,
    onCancel: VoidFunction,
    reset: UseFormReset<FieldValues>,
    submitLabel: string
}

export default function ModalForm({ open, title, onSubmit, children, onCancel, reset, submitLabel }: ModalFormProps) {
    const appContext = useContext(AppContext)
    useEffect(() => {
        if (!open) {
            reset()
        }
    }, [open])

    return (<Dialog
        open={open && !appContext?.appDialogInfo.isOpen}
        scroll={'paper'}
        fullWidth
        maxWidth='lg'>
        <ErrorBoundary onAccept={onCancel}>
            <DialogTitle >
                <span className='m-auto d-flex-center'>
                    <FontAwesomeIcon icon={title.icon} style={{ marginRight: '0.5rem' }} />
                    {title.label}
                </span>
            </DialogTitle>
            {open && <DialogContent style={{ padding: '0' }} dividers className="scroll-app">
                <form className="form-contain" autoComplete="off">
                    {children}
                </form>
            </DialogContent>}
            <DialogActions sx={{ alignContent: 'center' }}>
                <Button
                    color='inherit'
                    variant='contained'
                    disabled={appContext?.loading}
                    sx={{ boxShadow: '0' }}
                    onClick={onCancel} >
                    Cancelar
                </Button>
                <Button
                    className='app-btn-color'
                    variant='contained'
                    disabled={appContext?.loading}
                    onClick={onSubmit} >
                    {appContext?.loading ? <CircularProgress size={'1.5rem'} color='warning' /> : submitLabel}
                </Button>
            </DialogActions>
        </ErrorBoundary>
    </Dialog>
    )
}
